import { supabase } from "@/integrations/supabase/client";
import { fetchAllRows } from "@/lib/paginate";

export const PROPERTY_CARD_COLUMNS =
  "id, slug, title, title_en, title_pt, operation, property_type, price_amount, price_currency, address_text, bedrooms, bathrooms, garage_spots, area_m2, is_featured, is_opportunity, amenities, created_at";

export type PublicPropertyFilters = {
  operation?: string;
  property_type?: string;
  location_slug?: string;
  project_name?: string;
};

/** Listado público de propiedades. Se usa tanto en loaders (SSR) como en el cliente. */
export async function fetchPublicProperties(filters: PublicPropertyFilters) {
  let locId: string | null = null;
  if (filters.location_slug) {
    const { data: loc } = await supabase
      .from("locations")
      .select("id")
      .eq("slug", filters.location_slug)
      .maybeSingle();
    locId = loc?.id ?? null;
  }
  return fetchAllRows((from, to) => {
    let q = supabase.from("properties").select(PROPERTY_CARD_COLUMNS).neq("status", "borrador");
    if (filters.operation) q = q.eq("operation", filters.operation);
    if (filters.property_type) q = q.eq("property_type", filters.property_type);
    if (locId) q = q.eq("location_id", locId);
    if (filters.project_name) q = q.eq("address_text", filters.project_name);
    return q
      .order("is_featured", { ascending: false })
      .order("created_at", { ascending: false })
      .range(from, to);
  });
}


/** Artículos publicados del blog. */
export async function fetchPublishedArticles() {
  const { data } = await supabase
    .from("articles")
    .select("id, slug, title, title_en, title_pt, excerpt, excerpt_en, excerpt_pt, cover_url, published_at")
    .eq("published", true)
    .order("published_at", { ascending: false });
  return data ?? [];
}

/** Perfil del agente. */
export async function fetchAgentProfile() {
  const { data } = await supabase
    .from("agent_profile")
    .select("*")
    .order("updated_at", { ascending: false })
    .limit(1)
    .maybeSingle();
  return data;
}
